import {VGLawCookie} from "vglawcookie";

let lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.headerScroll($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.headerScroll($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		//
		$('.vg-nav').vegasMenu();

		//
		$('.nice-select').niceSelect();

		//
		let $ranges = $(".js-range-slider");
		if ($ranges.length) {
			$ranges.each(function () {
				let $ionRange = $(this);

				$ionRange.ionRangeSlider({
					skin: "round",
					onChange: function (data) {
						$ionRange.closest('.vg-catalog-sidebar__widget').find('[data-number=from]').val(data.from);
						$ionRange.closest('.vg-catalog-sidebar__widget').find('[data-number=to]').val(data.to);
					}
				});
			});
		}

		$('[data-number]').on('input keyup', function () {
			let $_self = $(this),
				type = $_self.data('number'),
				$range = $_self.closest('.vg-catalog-sidebar__widget').find('.js-range-slider'),
				$slider = $range.data("ionRangeSlider");

			if (type === 'from') {
				$slider.update({
					from: $_self.val()
				});
			}

			if (type === 'to') {
				$slider.update({
					to: $_self.val()
				});
			}

			return false
		});

		// Input mask
		let $input_mask = $('[data-mask]');
		if ($input_mask.length) {
			$input_mask.each(function () {
				let $self = $(this);

				let mask, data = $self.data('mask'), id = $self.attr('id');

				if (id) {
					if (data === 'card-barcode') {
						mask = '9999999999999';
					}

					if (data === 'card-number') {
						mask = '99999';
					}

					if (data === 'phone') {
						mask = '+79999999999';
					}
					Inputmask({
						"mask": mask,
						"showMaskOnFocus": true,
						"showMaskOnHover": false
					}).mask('#' + id);
				}
			});
		}

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		OwlVegas.init('owl-carousel');
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	headerScroll: function($self) {
		let $sticky = $('.vg-header-fixed'),
			scroll = $self.scrollTop(),
			scroll_hide = 48;

		if (scroll > 200) {
			$body.addClass('header--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -scroll_hide);
				$body.removeClass('header--is-fixed');
			} else {
				$sticky.css('top', 0);
				$body.addClass('header--is-fixed');
			}

			lastScrollTop = scroll;

		} else {
			$sticky.css('top', -scroll_hide);
			$body.removeClass('header--is-scroll header--is-fixed');
		}
	}
};
